<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/normal_user_list')">区域管理</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='关键字'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入区域名称"
            >
              <el-button
                slot="append"
                v-on:click="handleSearch"
              >搜索</el-button>

            </el-input>
            <el-button
            v-if="hasPower('40081991')"
              type="success"
              v-on:click="showEditGroup1"
            >新增区域</el-button>
            <span style="color: #666;line-height: 28px;font-size:14px;">注意:搜索结果将在下方列表呈现。</span>
          </el-form-item>

          <!-- <el-row>
            <el-col :span="7">
              <el-form-item label="用户状态">
                <el-select
                  v-model="filters.status"
                  placeholder="请选择"
                >
                  <el-option
                    label="可用"
                    value="1"
                  ></el-option>
                  <el-option
                    label="禁用"
                    value="2"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          v-loading='tableDataLoading'
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="title"
            label="区域名称"
          >

          </el-table-column>

          <el-table-column
            prop="username"
            label="管理员"
          >
          </el-table-column>
          <el-table-column
            prop="province"
            label="省份"
          >
          
          </el-table-column>
          
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">

              <el-dropdown v-if="hasPower('40081991')">
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" >
                  
                  <el-dropdown-item
                    v-if="scope.row.status==1"
                    command="b"
                    @click.native="upHouseStatus(scope.row, 2)"
                  >删除</el-dropdown-item>

                  <el-dropdown-item
                    command="f"
                    @click.native="showEditGroup(scope.row)"
                  >修改</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="修改区域"
      :visible.sync="dialogEditVisible"
      width="30%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        ref="form"
        :model="form"
        :rules="editUserRule"
      >
        <el-form-item
          label="名称"
          prop="title"
        >
          <el-input
            v-model="form.title"
            placeholder="请输入名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
         

           <el-form-item label="管理员">
            <el-select
              v-model="form.user_id"
              placeholder="请选择"
            >
              <el-option
              v-for="option in recoOptions"
              :value="option.id"
              :key="option.id"
              :label="option.username"
            ></el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="省份">
            <el-select
              v-model="form.province_list"
              placeholder="请选择"
              multiple
            >
              <el-option
              v-for="option in proList"
              :value="option"
                :key="option"
                :label="option"
            ></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="throwGroupUp()"
            :loading="addLoading"
          >提交</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="新增区域"
      :visible.sync="dialogEditVisible1"
      width="30%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        ref="form"
        :model="form"
        :rules="addUserRule"
      >
        <el-form-item
          label="名称"
          prop="title"
        >
          <el-input
            v-model="form.title"
            placeholder="请输入名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
         

           <el-form-item label="管理员" prop="user_id">
            <el-select
              v-model="form.user_id"
              placeholder="请选择"
            >
              <el-option
              v-for="option in recoOptions"
              :value="option.id"
              :key='option.id'
              :label="option.username"
            ></el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="省份" prop="province_list">
            <el-select
              v-model="form.province_list"
              placeholder="请选择"
              multiple
            >
              <el-option
              v-for="option in proList"
              :value="option"
                :key="option"
                :label="option"
            ></el-option>
            </el-select>
          </el-form-item>

          <el-button
            type="primary"
            @click="throwGroupUp1()"
            :loading="addLoading1"
          >提交</el-button>
          <el-button @click="dialogEditVisible1 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>

</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "manager_user_list",
  created() {},

  data() {
    return {
      powers:[],
      roleForm: {
        id: null,
        powers: null
      },
      defaultProps: {
        children: "children",
        label: "label"
      },
      roleLoading: false,
      dialogRoleVisible: false,
      recoOptions: [],
      proList:[],
      dialogEditVisible: false,
      tableDataLoading: false,
      bankListVisible: false,
      addLoading: false,
      addLoading1: false,
      bankListVisibleLoading: false,
      searchUserId: null,
      addPassLoading: false,
      tableData1: [],
      dialogEditPassVisible: false,
      dialogEditVisible1: false,
      addUserRule: {
        title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
       user_id: [{ required: true, message: "请选择管理员", trigger: "blur" }],
        province_list: [
          {
            required: true,
            message: "请选择省份",
            trigger: "blur"
          }
        ]
      },

      editUserRule: {
         title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        user_id: [{ required: true, message: "请选择管理员", trigger: "blur" }],
        province_list: [
          {
            required: true,
            message: "请选择省份",
            trigger: "blur"
          }
        ]
      },
      form: {
        id: null,
        user_id: null,
        province_list: null,
        title: null
      },
      filters: {
        title: null,
        status: null
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch(1);
  },
  methods: {
    
    showEditGroup1(row) {
      this.form.id = null;
      this.form.user_id = null;
      this.form.province_list = null;
      this.form.title = null;
      this.dialogEditVisible1 = true;
    },
    showEditGroup(row) {
      this.form.id = row.id;
      
      this.form.user_id = (JSON.parse(row.userId)).id;
      console.log(this.form.user_id)
      this.form.province_list = JSON.parse(row.provinceList);
      this.form.title = row.title;
      this.dialogEditVisible = true;
    },
    goDetail(row) {
      this.$router.push({ path: "/user_detail", query: { id: row.id } });
    },
hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },

    throwGroupUp() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.province_list = JSON.stringify(para.province_list);
          that.recoOptions.forEach(element => {
            if (para.user_id == element.id)
            {
              para.user_id = JSON.stringify({"id":element.id, "username":element.username})
            }
          });
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.add_up_area_info(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.dialogEditVisible = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.addLoading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },

    throwGroupUp1() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          para.province_list = JSON.stringify(para.province_list)
          that.recoOptions.forEach(element => {
            if (para.user_id == element.id)
            {
              para.user_id = JSON.stringify({"id":element.id, "username":element.username})
            }
          });
          that.addLoading1 = true;
          API.add_up_area_info(para)
            .then(
              function(result) {
                that.addLoading1 = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.dialogEditVisible1 = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.addLoading1 = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading1 = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },
    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("确定删除该区域吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: status
            };
            API.status_area_info(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch(getInfo) {
      this.page_size = 10;
      this.page_num = 1;
      this.search(getInfo);
    },
    search(getInfo) {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      params.getInfo = getInfo;
      that.tableDataLoading = true;
      API.area_info_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i=0; i<result.result.list.length; i++)
                {
                  result.result.list[i].username = JSON.parse(result.result.list[i].userId).username;
                  result.result.list[i].province = JSON.parse(result.result.list[i].provinceList).join(",")
                }
              }
              that.tableData = result.result.list;
              if (result.result.map != null)
              {
                that.recoOptions = result.result.map.recoOptions;
                that.proList = result.result.map.proList;
              }

            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/areaList.vue